import type { IconProps } from '@percent/lemonade'

export type SelectOptionCardProps = {
  testId: string
  icon?: IconProps['name']
  badge?: string
  title: string
  description?: string
  active: boolean
  onClick: VoidFunction
}
